"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
function Clock({ format = 'HH:mm:ss' }) {
    const [, setDate] = react_1.useState(Date.now());
    react_1.useEffect(() => {
        const interval = setInterval(() => {
            setDate(Date.now());
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    });
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: date_fns_1.format(Date.now(), format) }, void 0);
}
exports.Clock = Clock;
//# sourceMappingURL=index.js.map